





import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class StateTag extends Vue {
  @Prop({ type: String, default: null }) state: string
  @Prop({ type: String, default: 'is-small' }) size: string
  @Prop({ type: Boolean, default: false }) singular: boolean
}
